import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.gubcpc.com";

let accessToken = localStorage.getItem("adminAccessToken") || null;

export const setAccessToken = (token) => {
  accessToken = token;
  if (token) {
    localStorage.setItem("adminAccessToken", token);
  } else {
    localStorage.removeItem("adminAccessToken");
  }
};

export const clearAccessToken = () => {
  setAccessToken(null);
};

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  if (accessToken && config.url?.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (
      error.response?.status === 401 &&
      original?.url?.startsWith("/admin") &&
      !original?._retry &&
      original?.url !== "/admin/login" &&
      original?.url !== "/admin/refresh-token"
    ) {
      original._retry = true;
      try {
        const refresh = await instance.post("/admin/refresh-token");
        const newToken = refresh.data?.token;
        if (newToken) {
          setAccessToken(newToken);
          original.headers.Authorization = `Bearer ${newToken}`;
          return instance(original);
        }
      } catch (refreshErr) {
        clearAccessToken();
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
